<template>
  <div ref="header">
    <v-navigation-drawer
      class="hidden-md-and-up header-one-page-nav-drawer"
      v-model="drawer"
      fixed
    >
      <v-list-item class="pa-5">
        <div class="logo">
          <img
            src="../../../assets/images/layout/smile-logo.svg"
            alt="Creative Agency Logo"
          />
        </div>
        <v-spacer></v-spacer>
        <v-btn
          class="close-icon"
          icon
          @click="drawer = !drawer"
          v-html="iconSvg(closeIcon)"
        >
        </v-btn>
      </v-list-item>
      <scrollactive
        active-class="v-btn--active"
        bezier-easing-value=".5,0,.35,1"
        :offset="71"
      >
        <v-list>
          <v-list-item
              :ripple="false"
              :to="nucleo.to"
              link
              class="scrollactive-item"
          >
            <v-list-item-content>
              <v-list-item-title>{{ nucleo.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
              v-for="item in prensaMobile"
              :key="item.title"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
                link
                :ripple="false"
                v-for="child in item.items"
                :to="child.to"
                :key="child.title"
                :active-class="{'menu-item-selected': $route.query.category === item.category}"
            >
              <v-list-item-content>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            :ripple="false"
            v-for="item in items"
            :key="item.title"
            :to="item.to"
            link
            class="scrollactive-item"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- End mobile menu sidebar item list -->
        </v-list>
      </scrollactive>
    </v-navigation-drawer>
    <!-- End sidebar mobile menu -->

    <v-app-bar
      dark
      color="transparent"
      fixed
      elevate-on-scroll
      class="header-one-page-nav"
    >
      <router-link to="/" class="logo">
        <slot name="logo"></slot>
        <slot name="logo-dark"></slot>
      </router-link>
      <!-- End brand logo -->
      <v-spacer></v-spacer>
      <v-btn
        icon
        class="ma-0 pa-0 hidden-md-and-up"
        @click="drawer = !drawer"
        v-html="iconSvg(icon)"
      >
      </v-btn>
      <!-- End mobile menu icon -->
      <v-toolbar-items class="hidden-xs-only hidden-sm-only height-auto">
        <scrollactive
          active-class="v-btn--active"
          bezier-easing-value=".5,0,.35,1"
          :offset="71"
        >
          <v-btn
              :ripple="false"
              text
              :to="nucleo.to"
              :class="{'color-grey': $route.name === 'Nucleo central' || $route.name === '404'}"
              :style="{'color': `${color} !important`}"
          >{{ nucleo.title }}</v-btn>
          <v-menu
              open-on-hover
              bottom
              min-width="240"
              offset-y
              transition="scroll-y-reverse-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :ripple="false"
                  text
                  v-bind="attrs"
                  v-on="on"
                  :class="{'color-grey': $route.name === 'Nucleo central' || $route.name === '404'}"
                  :style="{'color': `${color} !important`}"
              >
                Prensa
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  link
                  v-for="(item, index) in prensa"
                  :key="index"
                  :to="item.to"
                  class="color-black"
                  :class="{'menu-item-selected': $route.params.categoria === nucleo.category}"
                  :style="{'color': `${color} !important`}"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
              v-for="item in items"
              :key="item.title"
              :to="item.to"
              link
              :ripple="false"
              text
              class="scrollactive-item"
              :class="{'menu-item-selected': $route.params.categoria === nucleo.category, 'color-grey': $route.name === 'Nucleo central' || $route.name === '404'}"
              :style="{'color': `${color} !important`}"
          >{{ item.title }}</v-btn>
        </scrollactive>
      </v-toolbar-items>
      <!-- End header menu item -->
    </v-app-bar>
    <!-- End top header navbar -->
  </div>
</template>
<style>
.v-menu__content .v-list-item {
  color: transparent !important;
  background-color: transparent !important;
}

.v-menu__content .v-list-item.v-list-item--active {
  color: transparent !important;
  background-color: transparent !important;
}

.v-menu__content .v-list-item.v-list-item--active.menu-item-selected {
  color: #f9004d !important;
}

.v-menu__content .v-list-item .v-list-item__title {
  color: black !important;
}

.color-grey {
  color: #c6c9d8 !important;
}

.color-black {
  color: black;
}

</style>
<script>
import feather from "feather-icons";
export default {
  props: {
    defaultColor: {
      type: String, // Tipo de dato opcional (puedes ajustarlo según tus necesidades)
      default: '#c6c9d8', // Valor predeterminado si no se proporciona
    },
  },
  created() {
    this.color = this.defaultColor;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data: () => ({
    scrollThreshold: 90,
    color: null,
    drawer: false,
    nucleo: { title: "Nucleo Central", to: "/" },
    prensa: [
      {title: "Cine & Series©", category: "cine-series", to: "/blog/categoria/cine-series"},
      {title: "Música", category: "musica", to: "/blog/categoria/musica"},
      {title: "Arte & Cultura", category: "arte-cultura", to: "/blog/categoria/arte-cultura"},
      {title: "Entrevistas", category: "entrevistas", to: "/blog/categoria/entrevistas"},
      {title: "El absurdo", category: "el-absurdo", to: "/blog/categoria/el-absurdo"},
    ],
    prensaMobile: [
      {
        items: [
          {title: "Cine & Series©", category: "cine-series", to: "/blog/categoria/cine-series"},
          {title: "Música", category: "musica", to: "/blog/categoria/musica"},
          {title: "Arte & Cultura", category: "arte-cultura", to: "/blog/categoria/arte-cultura"},
          {title: "Entrevistas", category: "entrevistas", to: "/blog/categoria/el-absurdo"},
          {title: "El absurdo", category: "el-absurdo", to: "/blog/categoria/el-absurdo"},
        ],
        title: "Prensa",
      },
    ],
    items: [
      { title: "Comunicación", to: "/comunicacion" },
      { title: "Smiletalents", to: "/smiletalents" },
      { title: "Contacto", to: "/contacto" },
      { title: "Equipo", to: "/equipo" },
    ],
    icon: "menu",
    closeIcon: "x",
  }),
  methods: {
    handleScroll() {
      if (window.scrollY > this.scrollThreshold) {
        // Cambiar el color de fondo a negro si la altura de scroll supera el umbral
        this.color = 'black';
      } else {
        if (this.$route.name === 'Nucleo central' || this.$route.name === '404' || this.$route.name === 'Contacto' || this.$route.name === 'Article') {
          this.color = '#c6c9d8';
        } else {
          this.color = 'black';
        }
      }
    },
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
